import { HttpRequest } from "./httpRequest";

export async function getTmlvData() {
  try {
    await HttpRequest.getTMLV();

    const _tmlvData = localStorage.getItem("tmlv");
    if (!_tmlvData) return null;

    const Tmlv = JSON.parse(_tmlvData);
    if (!Tmlv || !Tmlv[0]) return null;

    return {
      mesUsura: Tmlv[0].date ?? "",
      tasaUsura: `${Tmlv[0].rate}${Tmlv[0].percent} ${Tmlv[0].text}`,
      tasaUsuraTmlvRate: Tmlv[0].rate,
    };
  } catch (error) {
    console.error("Error obteniendo TMLV", error);
    return null;
  }
}
